import React from "react"
import DashboardTabs from "./DashboardTabs"

const Header = () => (
  <div className="px-7 pt-6 pb-2 flex items-end justify-between gap-4 flex-wrap">
    <div>
      <h1 className="text-[22px] font-bold tracking-tight text-slate-900">
        {I18n.t("chantiers_dashboard.title")}
      </h1>
      <p className="text-[12.5px] text-slate-500 mt-0.5">
        {I18n.t("chantiers_dashboard.subtitle")}
      </p>
    </div>
    <DashboardTabs active="activity" />
  </div>
)

export default Header
